import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getGruposHomogenio () {
   return Api().get("/grupo-homogenio-exposicions");
},
  updateGruposHomogenio (params) {
    return Api().put("/grupo-homogenio-exposicions",params);
  },
  addGruposHomogenio (params) {
    return Api().post("/grupo-homogenio-exposicions",params);
  },
  getGrupoHomogenio (params) {
    return Api().get("/grupo-homogenio-exposicions/"+params);
  },
  deleteGruposHomogenio (params) {
    return Api().delete("/grupo-homogenio-exposicions/"+params);
  },
  getGruposHomogenioByCompany (params) {
    return Api().get("/grupo-homogenio-exposicions-company/"+params);
  },
  deleteGruposHomogenioByCompany (params) {
    return Api().delete("/grupo-homogenio-exposicions-company/"+params);
  },
}



// WEBPACK FOOTER //
// ./src/services/GrupoHomogenioExposicionService.js